import React from "react";
import loadable from "@loadable/component";
import { Routes, Route } from "react-router-dom";

const Home = loadable(() => import("./pages/Home"));
const PrivacyPolicy = loadable(() => import("./pages/PrivacyPolicy"));
const TermsOfService = loadable(() => import("./pages/TermsOfService"));
const Contact = loadable(() => import("./pages/Contact"));
const ImageToPdf = loadable(() => import("./pages/tools/ImageToPdf"));
const ImageCrop = loadable(() => import("./pages/tools/ImageCrop"));
const ReduceImageSize = loadable(() => import("./pages/tools/ReduceImageSize"));
const PngToJpg = loadable(() => import("./pages/tools/PngToJpg"));
const XmlViewer = loadable(() => import("./pages/tools/XmlViewer"));
const JsonViewer = loadable(() => import("./pages/tools/JsonViewer"));
const TextBase64 = loadable(() => import("./pages/TextBase64"));
const HtmlEntitiesConverter = loadable(() => import("./pages/HtmlEntitiesConverter"));
const TextBaseConverter = loadable(() => import("./pages/TextBaseConverter"));
const TextCaseConverter = loadable(() => import("./pages/TextCaseConverter"));
const DateTimeConverter = loadable(() => import("./pages/DateTimeConverter"));
const JsonViewerTools = loadable(() => import("./pages/jsonViewer"));
const ImageToPdfTools = loadable(() => import("./pages/ImageToPdf"));
const ImageCropper = loadable(() => import("./pages/ImageCropper"));
const VoiceToText = loadable(() => import("./pages/voice-to-text"));
const DigitConverter = loadable(() => import("./pages/DigitConverter"));
const BlogReader = loadable(() => import("./pages/BlogReader"));
const BlogPost = loadable(() => import("./pages/BlogPost"));
const CreateBlog = loadable(() => import("./pages/CreateBlog"));

const App = ({ initialData = {} }) => {
  return (
    <Routes>
      <Route path="*" element={<Home />} />
      <Route path="/" element={<Home />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/json-viewer-article" element={<JsonViewer />} />
      <Route path="/image-to-pdf-article" element={<ImageToPdf />} />
      <Route path="/image-crop" element={<ImageCrop />} />
      <Route path="/reduce-image-size" element={<ReduceImageSize />} />
      <Route path="/png-to-jpg" element={<PngToJpg />} />
      <Route path="/xml-viewer" element={<XmlViewer />} />
      <Route path="/base64" element={<TextBase64 />} />
      <Route path="/html-entity" element={<HtmlEntitiesConverter />} />
      <Route path="/text-base-converter" element={<TextBaseConverter />} />
      <Route path="/text-case-converter" element={<TextCaseConverter />} />
      <Route path="/date-converter" element={<DateTimeConverter />} />
      <Route path="/json-viewer" element={<JsonViewerTools />} />
      <Route path="/image-to-pdf" element={<ImageToPdfTools />} />
      <Route path="/image-cropper" element={<ImageCropper />} />
      <Route path="/voice-to-text" element={<VoiceToText />} />
      <Route path="/digit-converter" element={<DigitConverter />} />
      <Route path="/blog" element={<BlogReader />} />
      <Route path="/blog/:slug" element={<BlogPost initialBlog={initialData.blog} />} />
      <Route path="/create-blog" element={<CreateBlog />} />
    </Routes>
  );
};

export default App;